var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('SatelliteImageReference',{attrs:{"image":_vm.image}}),(_vm.statistics)?_c('span',[_c('IxRes',{attrs:{"context":{
        stDev: _vm.$i18n.format(_vm.statistics, 'f2')
      }}},[_vm._v("\n      frs.zoneMap.details.image.standardDeviation\n    ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }